import React from 'react';
import FlowdoLoader from '../FlowdoLoader/FlowdoLoader';
import './LoadingSpinner.css';

export default function LoadingSpinner({
  variant = 'page',
  label = 'Loading…',
  className = '',
}) {
  const wrapClass = [
    'loading-container',
    variant === 'page' ? 'loading-container--page' : '',
    variant === 'compact' ? 'loading-container--compact' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const size = variant === 'compact' ? 'sm' : 'md';

  return <FlowdoLoader label={label} size={size} className={wrapClass} />;
}
